<div class="pane-container">
  <app-ecolog-overview title="EcoLogs" (selection)="onShortcut($event)"></app-ecolog-overview>
  <app-action-pane criteria="Delivery Reference" domain="none" [hint]="['Serial', 'Version', 'Container']" [print]="true" (action)="onAction($event)"
    (magic)="onSearch({ magic: $event })" (search)="onSearch({ deliveryRef: $event})"></app-action-pane>
  <app-ecolog-filter (filterChange)="onFilter($event)"></app-ecolog-filter>
</div>
<app-ecolog-list #list [sorting]="sorting" (event)="onEvent($event)" (page)="onScroll()" (sort)="onSort($event)"></app-ecolog-list>
